/*
 _______________________________________________________
/ This code was generated by a tool.                    \
|                                                       |
| Changes to this file may cause incorrect behavior and |
\  will be lost if the code is regenerated.             /
 -------------------------------------------------------
       \   ,__,
        \  (oo)____
           (__)    )\
              ||--|| *
*/
enum ElectronicServiceTimelineAliases {
  ADDITIONAL_HOURS_QUANTITY_FIELD = 'additional-hours-quantity-field',
  ADDITIONAL_HOURS_QUANTITY_INPUT = 'additional-hours-quantity-input',
  BEDSIDE_TIMELINE = 'bedside-timeline',
  CONTEXTUAL_BAR = 'contextual-bar',
  EMAR_TIMELINE_LAYOUT = 'emar-timeline-layout',
  FRAGMENT_INFORMATION_BAR_HEADER = 'fragment-information-bar-header',
  PERFORMED_CHECKBOX = 'performed-checkbox',
  PERFORMED_ITEMS_FIELD = 'performed-items-field',
  PRESCRIPTION_DATE_DATE_FIELD = 'prescription-date-date-field',
  PRESCRIPTION_DATE_FIELD = 'prescription-date-field',
  PRESCRIPTION_HOUR_DATE_FIELD = 'prescription-hour-date-field',
  PRESCRIPTION_HOUR_FIELD = 'prescription-hour-field',
  PREVIOUS_HOURS_QUANTITY_FIELD = 'previous-hours-quantity-field',
  PREVIOUS_HOURS_QUANTITY_INPUT = 'previous-hours-quantity-input',
  RESERVED_BLOOD_PRODUCTS_FRAGMENT_REFERENCE = 'reserved-blood-products-fragment-reference',
  RESERVED_BLOOD_PRODUCTS_PANEL = 'reserved-blood-products-panel',
  TIMELINE_FILTER = 'timeline-filter',
  TIMELINE_FILTERED_LIST = 'timeline-filtered-list',
  TIMELINE_LEGENDS = 'timeline-legends',
  TIMELINE_PANEL = 'timeline-panel',
}
export { ElectronicServiceTimelineAliases };
